import { Form } from '@/components/forms';
import { Select, Textarea } from '@mantine/core';
import { FormikProps } from 'formik';

enum ReasonForDeletion {
	NOT_AS_EXPECTED = 'The Curby service is not what I expected',
	TOO_EXPENSIVE = 'The Curby subscription is too expensive for me',
	REWARDS_NOT_APPEALING = 'The Curby Rewards program no longer appeal to me',
	FOUND_ALTERNATIVE = 'I have found a different way to recycle that suits me better',
	NO_LONGER_NEED = 'I no longer need to recycle',
	OTHER = 'Other (please comment)',
	MOVED_OUT = 'I have moved out of a Curby LGA',
}

export interface DeleteAccountValues {
	reasonForDeletion: ReasonForDeletion | '';
	comments: string;
}

type FormProps = {
	formRef: React.RefObject<FormikProps<DeleteAccountValues>>;
	onSubmit: (values: DeleteAccountValues) => void;
};

export const DeleteAccountForm = ({ onSubmit, formRef }: FormProps) => {
	const initialValues: DeleteAccountValues = {
		reasonForDeletion: '',
		comments: '',
	};

	return (
		<Form initialValues={initialValues} onSubmit={onSubmit} innerRef={formRef}>
			{({ getFieldProps, errors, touched, setFieldValue, values }) => (
				<>
					<Select
						label="Reason for deletion"
						placeholder="Select a reason"
						data={Object.values(ReasonForDeletion)}
						// @todo: getFieldProps is not mapping to Formik values/set-values
						// {...getFieldProps('reasonForDeletion')}
						value={values.reasonForDeletion}
						onChange={(value) => setFieldValue('reasonForDeletion', value)}
						error={touched.reasonForDeletion && errors.reasonForDeletion}
						mb="md"
					/>
					<Textarea
						label="Comments"
						placeholder="Enter any additional comments"
						{...getFieldProps('comments')}
						error={touched.comments && errors.comments}
						mb="md"
						rows={14}
					/>
				</>
			)}
		</Form>
	);
};
